/**
 * @Author: KOC Apps Admin <keremkoc>
 * @Date:   2018-06-01T14:35:12+03:00
 * @Email:  admin@kocapps.com
 * @Filename: config.js
 * @Last modified by:   keremkoc
 * @Last modified time: 2018-06-09T19:13:46+03:00
 */
(function($, root) {

  // $('header').hide();

  // Şu anki konfigürasyon 5:40 sürmektedir!

  $.config = function() {

    window.rdo = {
      currentpage: {
        url: null,
        title: null
      },
      loader: {
        loadingicon: $('#loading-icon'),
        pageOver: $('#page-overlay'),
        loaded: false,
        timeout: 1000,
        requesttimeout: 5000,
        introdone: false,
      },
      page: {
        pagewidth: null,
        pageheight: null,
        orientation: null

      },
      srix: {
        prixs: 'g._548pAE~aWKrs*!+VW;oNUs?P*DZ[Q]n)MrgN{(|Sf1hlY&LYn3/_O*D9KDCB',
        oddm: [1, 3, 5, 7, 8, 10, 12],
        evenm: [4, 6, 9, 11],
        singm: 2
      },
      // selected: {
      //   year: null,
      //   subject: null,
      //   content: null
      // },
      // next: {
      //   year: null,
      //   subject: null,
      //   content: null
      // },
      forms: {

      },
      pages: {

      },
      user: {

      },
      transitions: {
        content: 20000,
        transition: 500
      },
      timer: {
        paused: false,
        started: false,
        timer: null,
        hardpause: false
      },
      video: {
        playerDefaults: {
          // wmode:'opaque',
          autoplay: 0,
          autohide: 1,
          modestbranding: 1,
          rel: 0,
          showinfo: 0,
          controls: 0,
          // branding: 0,
          disablekb: 1,
          enablejsapi: 0,
          iv_load_policy: 3,
          // loop: 1
        },
        tv: null,
        currenttv: 'tv1',
        numPlayAttempts: 0,
        fit: 1.2,
        mute: true,
        // api:'https://www.youtube.com/player_api'
      },
      preloadCompleted: false,
      preloading: 'this',
      numpreloads: 0,
      requiredpreloads: 0,
      // currenttv: 'tv1',
      firscontent: true,

      header: {
        shown: false
      },
      index: {
        shown: false
      },
      modal: {
        shown: false
      },
      verticaltimeline: {
        scroll: {
          initialtop: 0,
          scroll_count: 1,
          scroll_interval: null

        },
        wait: 0
        // scroll_offsets_set: false
      },
      sitetitle: 'Mercedes - Gururla 50 Yıl'

    };

    if (process.env.NODE_ENV == 'development') {
      window.rdo.service = '/wp-json/rwpo_content/v1/getContent';

    } else if (process.env.NODE_ENV == 'production') {
      window.rdo.service = '/wp-json/rwpo_content/v1/getContent';

    }

    // window.rdo.queryContent = '/wp-json/rwpo_content/v1/queryContent';
    // window.rdo.querySubject = '/wp-json/rwpo_content/v1/querySubject';

    // $.templates({
    //   calPlayer:"render-template-calendar-player",
    //   vTimeline:"render-template-vertical-timeline",
    //   hTimeline:"render-template-horizontal-timeline"
    // });

  };
})(jQuery, this);
